import Axios from 'axios';

// Get CSRFToken for header in API call to db
Axios.defaults.xsrfCookieName = 'csrftoken';
Axios.defaults.xsrfHeaderName = 'X-CSRFToken';

export default class CheckoutCodeService {
  baseUrl = '/api/v3/pressrelease/validate-checkout-code';

  async validateCheckoutCode(code) {
    const url = this.baseUrl;
    const response = await Axios.post(url, { code });
    return response;
  }
}
